module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Light.981b29b.eot";